<template>
	<div style="display: flex;flex-flow: column;align-items: center;background-color: #fff;padding-bottom: 40px;">
<!--		<div class="userLeft_time">
			<p>会员到期时间：2023-05-25</p>
		</div>-->
<img style="width: 150px;height: 150px;margin-top: 20px;"
v-if="userAvatar" :src=userAvatar alt="">

<img v-if="!userAvatar" style="width: 150px;height: 150px;margin-top: 20px;"
src="../../../assets/img/head.png" alt="">

		<p style="font-size: 20px; font-weight: 600;margin-top: 20px;">{{userName}}</p>
		<!--<span style="margin-top: 10px;font-size: 16px;color: #a5a5a5;">ID：202200071</span>-->
		<div class="userLeftSelect">
			<p v-for="(item,index) in navList" :class="[selectIndex == index ?'useActive':'']" 
			:key="index" @click="changeSelect(item,index)">
				{{item.name}}
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

				userName:'',
				userAvatar:'',
				selectIndex:0,
				navList: [
					{
						name: '个人信息',
						path:'userinfo'
					},
					{
						name: '我的班级',
						path:'myclass'
					}, {
						name: '我的订单',
						path:'myorder'
					}]
					}
		},
		watch:{
			'$route':function () {
				if(this.selectIndex != this.$route.meta.uid){
					this.selectIndex = this.$route.meta.uid
				}
			}
		},
		created() {
			if(this.selectIndex != this.$route.meta.uid){
				this.selectIndex = this.$route.meta.uid
			}
			let userName    = localStorage.getItem('userName')
			let userAvatar  = localStorage.getItem('userAvatar')
			this.userName   = userName
			this.userAvatar = userAvatar
		},

		methods:{
			changeSelect(item,index){
				this.selectIndex = index
				this.$router.push('/'+item.path)
			}
		}
	}
</script>

<style scoped>
	.userLeft_time {
		height: 30px;
		line-height: 30px;
		width: 100%;
		text-align: center;
		color: #fff;
		background-color: #c19b61;
	}

	.userLeftSelect {
		margin-top: 50px;
	}

	.userLeftSelect p {
		cursor: pointer;
		width: 100%;
		text-align: center;
		display: inline-block;
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
	}
	.useActive{
		border-left: 4px solid #bc141c;
		background-color: #f6e1e0;
		color: #bc141c;
	}
</style>
